import { useParams } from "react-router-dom";
import { CommmonBoxLayout, CommonLayout } from "../style/common";
import Add from "../components/notice/Add";
import Content from "../components/notice/Content";

export default function NoticeDetail() {
  const { idx } = useParams<{ idx: string }>();
  const { add } = useParams<{ add: string | undefined }>();
  
  return (
    <CommonLayout>
      <CommmonBoxLayout>
        {idx && (idx === "add" || add  ? <Add /> : <Content useIdx={idx} />)}
      </CommmonBoxLayout>
    </CommonLayout>
  );
}